module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA6BAMAAAAeiydcAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURf/IXEdwTP+2JP+3NP/DTP+2JP+8Of+9Pf+9PP/IXP/JXf+2Jc/ULBcAAAAKdFJOU38AgB3F5EMtb+/WRfpQAAAA1klEQVQ4y+3UPw6CMBQG8M5MIsqAk65OJF7AuLFygl7HIzBBwqBvJJI06eWkpVL+foSwaOI3QMMvNA/6WubW8aKb2+SSh2bEzH1HueWIrj0OiCwTZd/APtNxiFgTorQecPV8Og+WIH4ygvlpTtlEHM2ZO5Hgz7146rLRbTfGe246dZwPBWZ5xPwKIcsYc8khywKzqg5xVV2Ht6dPzoqr6jqs32ml5JBlgVksmXymtJkPW/RbxJolide0A24mAVux1cjDw8Nsg5qHsbPMcYL5jtkfOdAsvwHq/PS9jxPwGQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/notification/booking_sent.png
// module id = 1815
// module chunks = 0